import type { Breakpoints, Palette } from '@mui/material/styles';

import type { Spacing } from '@mui/system';

declare module '@mui/material/styles/createMixins' {
  interface Mixins {
    appSvg: any;
    appContainer: any;
    appClickableContainer: any;
    appContainersSpacing: any;
    appLink: any;
    appLabel: any;
    appEllipsis: any;
    appIconTintSquare: any;
    appIconTintCircle: any;
  }
}

export enum SvgClass {
  disabled = 'svg-disabled',
  active = 'svg-active',
  expanded = 'svg-expanded',
}

export default function createMixins(
  breakpoints: Breakpoints,
  spacing: Spacing,
  palette: Palette,
) {
  return {
    appSvg: {
      [`& svg.${SvgClass.disabled}`]: {
        color: palette.grey[300],
      },

      [`& svg.${SvgClass.active}`]: {
        color: palette.primary.main,
      },

      '& svg': {
        color: palette.grey[600],

        [`&:not(.${SvgClass.disabled}):hover`]: {
          cursor: 'pointer',
          color: palette.primary.main,
        },
      },
    },

    appContainer: {
      boxSizing: 'border-box',
      backgroundColor: palette.background?.paper,
      borderRadius: '10px',
      padding: spacing(2),
      width: '100%',
      boxShadow: `${(palette as any).shadow} 0px 4px 16px -4px`,
      [breakpoints.down('md')]: {
        padding: spacing(2, 1.5),
      },
    },
    appClickableContainer: {
      backgroundColor: (palette as any).paper?.backgroundColor,
      borderRadius: '10px',
      padding: spacing(2),
      width: '100%',
      transition: 'border 0.3s ease',
      border: '1px solid transparent',
      cursor: 'pointer',
      boxShadow: `${(palette as any).shadow} 0px 4px 8px -4px`,

      [breakpoints.down('md')]: {
        padding: spacing(2, 1.5),
      },

      '&:hover': {
        borderColor: (palette as any).paper?.borderColor,
      },
    },
    appContainersSpacing: {
      '& + &': {
        marginTop: '8px',
      },
    },
    appLink: {
      cursor: 'pointer',
      transition: 'color 0.3s ease',

      '&:hover': {
        color: (palette as any).custom?.linkColor,
      },
    },
    appLabel: {
      color: (palette as any).font?.secondary,
      display: 'block',
      fontSize: '1rem',
      lineHeight: 1,

      position: 'static',
      transform: 'none',
      transformOrigin: 'left top',
    },
    appEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    appIconTintSquare: {
      flexShrink: 0,
      width: 48,
      height: 48,
      borderRadius: spacing(1.5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    appIconTintCircle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
    },
  };
}
